/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import * as constants from 'constants/Prestation'

const initialState = {
  selectedPrestation: null,
  prestations: [],
  origines: [],
  prestationTypes: [],
  skills: [],
  qualifications: [],
  beneficiaryNumberTypes: [],
  sexes: [],
  languages: [],
  staticLoaded: false,
  workflowSteps: []
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SELECT_PRESTATION:
      return {
        ...state,
        selectedPrestation: action.prestation,
      }

    case constants.SELECT_PRESTATIONS:
      return {
        ...state,
        prestations: action.prestations,
      }
      
    case constants.SET_DATA:
      return {
        ...state,
        [action.key]: action.data
      }
    case constants.SET_STATIC_LOADED:
      return {
        ...state,
        staticLoaded: true,
      }

    case constants.SELECT_WORKFLOW_STEPS:
      return {
        ...state,
        workflowSteps: action.workflow_steps,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/prestation/ApplicantPrestation.js